import { render, staticRenderFns } from "./unbind.vue?vue&type=template&id=d8d4e1b2&scoped=true"
import script from "./unbind.vue?vue&type=script&lang=js"
export * from "./unbind.vue?vue&type=script&lang=js"
import style0 from "./unbind.vue?vue&type=style&index=0&id=d8d4e1b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d4e1b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8d4e1b2')) {
      api.createRecord('d8d4e1b2', component.options)
    } else {
      api.reload('d8d4e1b2', component.options)
    }
    module.hot.accept("./unbind.vue?vue&type=template&id=d8d4e1b2&scoped=true", function () {
      api.rerender('d8d4e1b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userCenter/userList/unbind.vue"
export default component.exports